 // axios
import axios from 'axios'

// const baseURL = 'https://selfie.cash'
const baseURL = 'https://selfie.cash'

export default axios.create({
  baseURL
  // You can add your headers here
})
